import { useState, useRef, useEffect, useCallback } from 'react';
import { groupTranscriptBySentence, timeToSec } from '../../utils';

export const useTranscript = (currentTranscript, externalPlayerRef) => {
  const [scriptArr, setScriptArr] = useState([]);
  const [activeIdx, setActiveIdx] = useState(-1);
  const [autoScroll, setAutoScroll] = useState(true);
  const scriptRefs = useRef([]);
  const intervalRef = useRef(null);
  const scriptArrRef = useRef([]);

  useEffect(() => {
    if (currentTranscript) {
      const groupedScript = groupTranscriptBySentence(currentTranscript);
      setScriptArr(groupedScript);
      scriptArrRef.current = groupedScript;
      setActiveIdx(-1);
    } else {
      setScriptArr([]);
      scriptArrRef.current = [];
      setActiveIdx(-1);
    }
  }, [currentTranscript]);

  const onPlayerStateChange = useCallback((event) => {
    if (event.data === 1) { // playing
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          if (
            externalPlayerRef?.current &&
            typeof externalPlayerRef.current.getCurrentTime === 'function' &&
            scriptArrRef.current.length > 0
          ) {
            const currentTime = externalPlayerRef.current.getCurrentTime();
            
            const currentIdx = scriptArrRef.current.findIndex((item, idx) => {
              const startSec = timeToSec(item.time);
              const nextStartSec = scriptArrRef.current[idx + 1] ? timeToSec(scriptArrRef.current[idx + 1].time) : Infinity;
              return currentTime >= startSec && currentTime < nextStartSec;
            });
            
            if (currentIdx !== -1) {
              setActiveIdx(prevActiveIdx => {
                if (currentIdx !== prevActiveIdx) {
                  console.log(`자막 하이라이트 변경: ${prevActiveIdx} -> ${currentIdx}, 시간: ${currentTime}초`);
                  return currentIdx;
                }
                return prevActiveIdx;
              });
            }
          }
        }, 100);
      }
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
  }, [externalPlayerRef]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  return {
    scriptArr,
    activeIdx,
    autoScroll,
    setAutoScroll,
    scriptRefs,
    onPlayerStateChange
  };
}; 